import { addToRecord } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { ThreadHideFromCampaignFeedFulfilledAction } from '../../domains/hiddenThreads/campaignActions.types';

import type { HiddenThreads } from './types';

export type ThreadsHiddenFromFeedsAction = ThreadHideFromCampaignFeedFulfilledAction;

const initialState: HiddenThreads = {};

const reducer: Reducer<HiddenThreads, ThreadsHiddenFromFeedsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'THREAD.HIDE_FROM_CAMPAIGN_FULFILLED': {
      return addToRecord(state, action.payload.feedId, {
        ...state[action.payload.feedId],
        [action.payload.threadId]: true,
      });
    }
    default:
      return state;
  }
};

export default reducer;
